<template>
  <rolling-segment-page />
</template>

<script>
import RollingSegmentPage from './RollingSegmentPage'

export default {
  name: 'RollingSegmentPageUpdate',
  components: { RollingSegmentPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/RollingSegmentPageUpdate.vue